import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { Column } from 'seagull';
import styles from './scrollArea.module.scss';
import { useScrollState } from './useScrollState';
export const MessageScrollArea = (param)=>{
    let { children, testId, gap, fullWidth = false, padBottom = true } = param;
    const { scrolled, onScroll } = useScrollState();
    return /*#__PURE__*/ _jsx(Column, {
        gap: gap,
        testId: testId,
        onScroll: onScroll,
        className: cn(styles.scrollArea, styles.scrollItems, {
            [styles.padBottom]: padBottom,
            [styles.fullWidth]: fullWidth,
            [styles.scrolled]: scrolled
        }),
        children: children
    });
};
